module.exports = __webpack_public_path__ + "img/Strelica_position_zelena_desno.10a4b61d.svg";